import script from "./ViewBuildingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewBuildingView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__